import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SortOrder } from '@/components/ui/table'
import { VisitorHistoryModel } from '@/models'

export type GetVisitorHistoryRequest = {
  buildingId?: number
  search?: string
  skip?: number
  limit?: number
  start?: number
  end?: number
  clientId?: number[]
  sort?: string
  direction?: SortOrder
}

export type GetVisitorHistoryResponse = {
  history: VisitorHistoryModel[]
  count: number
}

export const GET_VISITOR_HISTORY_BASE_QUERY_KEY = 'useGetVisitorHistory'

export const getVisitorHistoryQueryKey = (data: GetVisitorHistoryRequest) => [
  GET_VISITOR_HISTORY_BASE_QUERY_KEY,
  data,
]

export const getVisitorHistory = async (
  data: GetVisitorHistoryRequest,
): Promise<GetVisitorHistoryResponse> => {
  const response = await authAPI.get('/visitor', { params: data })
  return response.data
}

export const useGetVisitorHistory = (data: GetVisitorHistoryRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: () => getVisitorHistory(data),
    queryKey: getVisitorHistoryQueryKey(data),
  })
}
